import api from "services/api";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_INFERENCE = API_URL_VERSION + "inferencia";
export const ENDPOINT_INFERENCE_RESOURCE = ENDPOINT_INFERENCE + "/recurso-processo";

export const inferenceService = {
  infer: async (data) => {
    try {
      const response = await api.post(`${ENDPOINT_INFERENCE_RESOURCE}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "process.messages.errors.infer";
    }
  },
};